import * as Yup from "yup";
export const reportAnIssueSchema = Yup.object().shape({
  feedback: Yup.string().required("This field is required"),
});
